import React from 'react';
import IconButton from 'material-ui/IconButton';
import CloseIcon from 'material-ui/svg-icons/navigation/close';
import { isNil } from 'lodash';
import { primaryColor } from '../theme'

export default ({ text, onClose, duration }) => {
    if (isNil(text) || text === '') {
        return null;
    }
    const style = duration
        ? { animationDuration: `${duration}s`, WebkitAnimationDuration: `${duration}s` }
        : {};
    return (
        <div className="cro-info-panel" style={style}>
            <div className="text">
                {text}
            </div>
            <div className="close-button">
                <IconButton onTouchTap={onClose} aria-label="Zavřít">
                    <CloseIcon color={primaryColor} />
                </IconButton>
            </div>
        </div>
    )
}